import React from 'react';
import PinwheelModal from './PinwheelModal';
import AtomicModal from './AtomicModal';

function PayrollProviderModal({
    provider = 'pinwheel',
    operation = 'verify',
    companyId = null,
    isOpen,
    linkToken,
    publicToken,
    hasPinwheel,
    setIsOpen,
    onSuccess,
    updateAccount,
    reauth,
    onContinue,
    onError,
}) {
    const effectiveToken = provider === 'atomic' ? (publicToken || linkToken) : linkToken;

    if (provider === 'atomic') {
        return (
            <AtomicModal
                isOpen={isOpen}
                operation={operation}
                companyId={companyId}
                publicToken={effectiveToken}
                hasPinwheel={hasPinwheel}
                setIsOpen={setIsOpen}
                onSuccess={onSuccess}
                updateAccount={updateAccount}
                reauth={reauth}
                onContinue={onContinue}
                onError={onError}
            />
        );
    }

    return (
        <PinwheelModal
            isOpen={isOpen}
            linkToken={effectiveToken}
            setIsOpen={setIsOpen}
            onSuccess={onSuccess}
            reauth={reauth}
            onContinue={onContinue}
            onError={onError}
        />
    );
}

export default PayrollProviderModal;
